enum OrderStatuses {
    paid = 'paid',
    not_paid = 'not_paid',
    refund_claim = 'refund_claim',
    refunded = 'refunded',
    refund_declined = "refund_declined"
}

export { OrderStatuses }